<template>
<div class="containers">
    <div v-if="goArea == true" class="area-list">
        <CAlert
        v-if="success == true"
        :show.sync="currentAlertCounter"
        closeButton
        style="background-color:rgba(48, 107, 221, 1);border-radius:0;text-align:center;color:white"
        >
        {{alertMess}}
        </CAlert>
        <CAlert
        v-else
        :show.sync="currentAlertCounter"
        closeButton
        style="background-color:red;border-radius:0;text-align:center;color:white"
        >
        {{alertMess}}
        </CAlert>
        <div class="search-area">
            <CRow>
                <CCol sm="5">
                    <input type="text" v-model="searchNama" placeholder="Nama Status" class="form-control"/>
                </CCol>
                <CCol sm="5">
                    <model-select :options="dataSearchAktif" style="background-color: #f9fafc" class="form-control model-select" v-model="searchAktif" placeholder="Pilih Aktif"></model-select>
                </CCol>
                <CCol sm="2">
                    <CButton @click="findData()" type="button" class="btn btn-search">Cari</CButton>
                </CCol>
            </CRow>
        </div>
        <div class="sticky1">
            <CRow>
                <CCol sm="4"></CCol>
                <CCol sm="6">
                    <span style="float:right">
                        <CButton v-if="page == 1" disabled style="cursor:default" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                        <CButton v-else @click="movePage('prev')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-left'}" /></CButton>
                        <CButton v-if="page == totalPage" style="cursor:default" disabled class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                        <CButton v-else @click="movePage('next')" class="rounded"><font-awesome-icon :icon="{prefix: 'fas', iconName: 'chevron-right'}" /></CButton>
                    </span>
                    <input @change="validatePage(page)" v-if="totalPage != 1" style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model.number="page" class="text-center rounded p-1" type="text">
                    <input v-else disabled style="border: 1px solid rgba(154, 154, 154, 1);width:50px;float:right" v-model="page" class="text-center rounded p-1" type="text">
                    <span class="mr-3 mt-1" style="color:rgba(154, 154, 154, 1);float:right"><span style="color:rgba(16, 16, 16, 1)">{{firstPage}} - {{lastPage}}</span> of {{totalRow}}</span>
                    <img class="mt-1 mr-5" :src="moreIcon" width="20px" height="20px" style="float:right"/>
                    <img class="mr-5 mt-1" @click="reload()" :src="refreshIcon" :class="classReload" width="20px" height="20px" style="float:right;cursor:pointer"/>
                </CCol>
                <CCol sm="2">
                    <CButton @click="moving()" type="button" class="btn btn-add">Tambah</CButton>
                </CCol>
            </CRow>
        </div>
        <Tables @sort="sorting" @edit="editData" :data="datas" :th="dataTh" :td="dataTd" :styleTable="styleTable" :errors="errorMessage"></Tables>
    </div>
    <div v-else class="area-edit">
        <CModal
            size="sm"
            :centered="true"
            title="Info Delete"
            color="danger"
            :show.sync="deleteModal"
            >
            <p>Apakah anda yakin ingin menghapus data?</p>
            <CRow>
                <CCol sm="6">
                    <CButton @click="deleteModal = false" class="btn btn-secondary w-100 text-center btn-cancel">Batal</CButton>
                </CCol>
                <CCol sm="6">
                    <CButton @click="goSave('D')" class="btn btn-danger w-100 text-center btn-delete">Ya, Hapus</CButton>
                </CCol>
            </CRow>
            <template #footer-wrapper><span></span></template>
        </CModal>
        <CRow class="area-back">
            <CCol sm="12">
                <img class="mt-2 mb-2" @click="moving()" :src="backIcon" width="20px" height="20px" style="float:left;cursor:pointer"/>
            </CCol>
        </CRow>
        <hr style="border: 1px solid rgba(238, 238, 238, 1)" class="p-0 m-0"/>
        <CRow class="area-input">
            <CCol sm="12">
                <CRow>
                    <CCol sm="6">
                        <label>Nama Status</label>
                        <input 
                            class="form-control" 
                            v-model.trim="$v.namaStatus.$model"
                            :class="{ 'is-invalid':$v.namaStatus.$error, 'is-valid': !$v.namaStatus.$invalid }"
                            placeholder="Nama Status" 
                            type="text"
                        />
                    </CCol>
                    <CCol sm="6">
                        <label>Description</label>
                        <input 
                            class="form-control" 
                            :class="{ 'is-invalid':$v.description.$error, 'is-valid': !$v.description.$invalid }"
                            v-model="description"
                            placeholder="Description" 
                            type="text"
                        />
                    </CCol>
                </CRow>
                <CRow>
                    <CCol sm="6">
                        <label>Reason</label>
                        <input 
                            class="form-control" 
                            v-model.trim="$v.reason.$model"
                            :class="{ 'is-invalid':$v.reason.$error, 'is-valid': !$v.reason.$invalid }"
                            placeholder="Reason" 
                            type="text"
                        />
                    </CCol>
                    <CCol sm="6">
                        <label>Approve By</label>
                        <model-select :options="dataApproveBy"
                            class="form-control model-select"
                            v-model.trim="$v.approveBy.$model"
                            :class="{ 'is-invalid select-invalid':$v.approveBy.$error, 'is-valid select-valid': !$v.approveBy.$invalid }"
                            placeholder="Pilih Approve By">
                        </model-select>
                    </CCol>
                </CRow>
                <CRow>
                    <CCol sm="6">
                        <label>Status</label>
                        <model-select :options="dataStatus"
                            class="form-control model-select"
                            v-model.trim="$v.status.$model"
                            :class="{ 'is-invalid select-invalid':$v.status.$error, 'is-valid select-valid': !$v.status.$invalid }"
                            placeholder="Pilih Status">
                        </model-select>
                    </CCol>
                    <CCol sm="6">
                        <label>Aktif</label>
                        <model-select :options="dataAktif"
                            class="form-control model-select"
                            v-model.trim="$v.aktif.$model"
                            :class="{ 'is-invalid select-invalid':$v.aktif.$error, 'is-valid select-valid': !$v.aktif.$invalid }"
                            placeholder="Pilih Role">
                        </model-select>
                    </CCol>
                </CRow>
                <CRow>
                    <CCol sm="6">
                        <label>Warna Dasar</label>
                        <input 
                            class="form-control" 
                            v-model.trim="$v.color.$model"
                            :class="{ 'is-invalid':$v.color.$error, 'is-valid': !$v.color.$invalid }"
                            placeholder="Warna" 
                            type="color"
                        />
                    </CCol>
                </CRow>
            </CCol>
        </CRow>
        <CRow class="area-button-submit mt-5">
            <CCol sm="12">
                <CButton @click="moving()" type="button" class="btn btn-cancel mr-2">Batal</CButton>
                <CButton v-if="tipe != 'C'" @click="deleteModal = true" class="btn btn-edit-delete mr-2">
                    <span>Delete</span>
                </CButton>
                <CButton @click="submitForm()" class="btn btn-edit-submit">
                    <span v-if="loading == false">Submit</span>
                    <CSpinner v-else color="default" size="sm"/>
                </CButton>
            </CCol>
        </CRow>
    </div>
</div>
</template>

<script>
import Tables from '../../../component/tableStatus'
import {DataApi} from "../../../service/DataApi";
import { required } from 'vuelidate/lib/validators'
import { validationMixin } from 'vuelidate'
import { ModelSelect } from 'vue-search-select'

export default {
    components: {
        Tables,
        ModelSelect
    },
    mixins: [validationMixin],
    validations: {
        namaStatus: {
            required
        },
        description: {
            required
        },
        reason: {
            required
        },
        color: {
            required
        },
        aktif: {
            value: {
                required
            },
            text: {
                required
            }
        },
        status: {
            value: {
                required
            },
            text: {
                required
            }
        },
        approveBy: {
            value: {
                required
            },
            text: {
                required
            }
        }
    },
    data() {
        return {
            success: true,
            refreshIcon: require('../../../assets/menu/icon_refresh.svg'),
            moreIcon: require('../../../assets/menu/icon_more.svg'),
            backIcon: require('../../../assets/menu/icon_goback.svg'),
            dataTh: ['Nama Status', 'Description', 'Reason', 'Approve', 'Status', 'Aktif', 'Action'],
            dataTd: ['nama', 'description', 'fieldReason', 'isPegawaiAtasan', 'isApproval', 'aktif', 'action'],
            styleTable: ['200px', '150px', '150px', '100px', '100px','100px', '100px'],
            classReload: 'reloadOff',
            goArea: true,
            loading: false,
            alertMess: '',
            currentAlertCounter: 0,

            // data model
            namaStatus: '',
            description: '',
            reason: '',
            color: '',
            dataApproveBy: [],
            dataStatus: [],
            dataAktif: [],
            approveBy: {
                value: '',
                text: ''
            },
            aktif: {
                value: '',
                text: ''
            },
            status: {
                value: '',
                text: ''
            },
            unix: '',
            tipe: 'C',


            // pagination
            page: 1,
            size: 20,
            totalRow: 0,
            totalPage: 1,
            firstPage: 0,
            lastPage: 0,

            // filter
            searchNama: '',
            dataSearchAktif: [],
            searchAktif: {
                value: '',
                text: ''
            },
            
            // datas
            datas: [],

            //error
            errorMessage: '',

            // delete
            deleteModal: false,
            flagSearch: false
        }
    },
    watch: {
        page() {
            window.scroll({
                top:0,
                left: 0,
                behavior: 'smooth'
            });
        },
        goArea() {
            window.scroll({
                top:0,
                left: 0,
                behavior: 'smooth'
            });
        },
        searchNama() {
            this.flagSearch = true
        },
        searchAktif() {
            this.flagSearch = true
        }
    },
    methods: {
        /**
         * GET DATA
         */
        sorting(value) {
            if(value == 0) {
                function compare(a,b) {
                    if (a.kodeJenis.toLowerCase() < b.kodeJenis.toLowerCase()) {
                        return -1
                    }
                    if (a.kodeJenis.toLowerCase() > b.kodeJenis.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            } else if(value == 1) {
                function compare(a,b) {
                    if (a.jenis.toLowerCase() < b.jenis.toLowerCase()) {
                        return -1
                    }
                    if (a.jenis.toLowerCase() > b.jenis.toLowerCase()) {
                        return 1
                    }
                    return 0
                }
                return this.datas.sort(compare)
            }
        },
        getData() {
            if(this.flagSearch == true) {
                this.page = 1
            }
            this.$store.state.loadingScreen = true
            let limit = this.size
            let page = this.page
            let aktif = this.searchAktif.value
            let description = ''
            let fieldReason = ''
            let isApproval = ''
            let isPegawaiAtasan = ''
            let nama = this.searchNama
            let payload = {
                aktif: aktif,
                description: description,
                fieldReason: fieldReason,
                isApproval: isApproval,
                isPegawaiAtasan: isPegawaiAtasan,
                limit: limit,
                nama: nama,
                pageIn: page
            }
            DataApi.post("overtime/status/approval/lihat", payload)
            .then(res => {
                let response = res.data
                if(response.success == true) {
                    this.datas = response.data.data
                    this.totalRow = response.data.totalRow
                    this.firstPage = (((this.page - 1) * this.size) + 1 )
                    this.lastPage = (((this.page - 1) * this.size) + this.datas.length )
                    this.totalPage = Math.floor(this.totalRow/this.size)
                    let modAr = this.totalRow%this.size
                    if(modAr != 0) {
                        this.totalPage = this.totalPage + 1
                    } else {
                        //
                    }
                } else {
                    this.datas = []
                    this.totalRow = 0
                    this.firstPage = 0
                    this.lastPage = 0
                    this.totalPage = 1
                    this.errorMessage = response.message
                }
                this.flagSearch = false
                this.$store.state.loadingScreen = false
            })
        },
        findData() {
            this.getData()
        },
        movePage(direction) {
            if(direction == 'prev') {
                this.page = this.page -  1
            } else {
                this.page = this.page +  1
            }
            this.getData()
        },
        validatePage(page) {
            if(page > this.totalPage) {
                this.page = this.totalPage
            }
        },
        reload() {
            this.searchNama = ''
            this.searchAktif.value = ''
            this.searchAktif.text = ''
            this.dataSearchAktif = []
            this.getDataSearchAktif()
            this.flagSearch = true
            this.getData()
            if (this.classReload == 'reloadOff') {
                this.classReload = 'reloadOn'
            } else {
                this.classReload = 'reloadOff'
            }
        },

        /**
         * ADD DATA
         */
        moving() {
            setTimeout(this.moveArea, 600);
        },
        moveArea() {
            if(this.goArea == true) {
                this.goArea = false
            } else {
                this.goArea = true
                this.namaStatus = ''
                this.description = ''
                this.reason = ''
                this.color = ''
                this.dataApproveBy = []
                this.dataStatus = []
                this.dataAktif = []
                this.approveBy.value = ''
                this.approveBy.text = ''
                this.aktif.value = ''
                this.aktif.text = ''
                this.status.value = ''
                this.status.text = ''
                this.getDataAktif()
                this.getDataStatus()
                this.getDataApproveBy()
                this.unix = ''
                this.tipe = 'C'
                this.$v.$reset()
            }
        },
        goSave(val) {
            let tipe = ''
            if(val == 'D') {
                tipe = val
            } else {
                tipe = this.tipe
            }
            let payload = {
                aktif: this.aktif.value,
                color: this.color,
                description: this.description,
                fieldReason: this.reason,
                isApproval: this.status.value,
                isPegawaiAtasan: this.approveBy.value,
                nama: this.namaStatus,
                tipe: val,
                unix: this.unix
            }
            DataApi.post("overtime/status/approval/simpan", payload)
            .then(res => {
                this.deleteModal = false
                let response = res.data
                if(response.success == true) {
                    if(response.data.Data1 == 'Y') {
                        this.success = true
                    } else {
                        this.success = false
                    }
                    this.alertMess = response.data.Data2
                } else {
                    this.alertMess = response.message
                    this.success = false
                }
                this.getData()
                this.moving()
                this.deleteModal = false
                this.loading = false
                this.currentAlertCounter = 7
            })
        },
        /**
         * EDIT DATA
         */
        editData(value) {
            let generate = this.datas[value]
            this.color = generate.color
            this.description = generate.description
            this.reason = generate.fieldReason
            this.namaStatus = generate.nama

            let data = this.dataAktif
            let data2 = this.dataStatus
            let data3 = this.dataApproveBy
            let aktif = generate.aktif
            let status = generate.isApproval
            let approveBy = generate.isPegawaiAtasan
            var i,j,k 
            for(i=0;i<data.length;i++) {
                if(aktif == data[i].value) {
                    this.aktif.value = data[i].value
                    this.aktif.text = data[i].text
                }
            }
            for(j=0;j<data2.length;j++) {
                if(status == data2[j].value) {
                    this.status.value = data2[j].value
                    this.status.text = data2[j].text
                }
            }
            for(k=0;k<data3.length;k++) {
                if(approveBy == data3[k].value) {
                    this.approveBy.value = data3[k].value
                    this.approveBy.text = data3[k].text
                }
            }
            this.unix = generate.unix
            this.tipe = 'u'
            this.moving()
        },

        /**
         * VALIDATION DATA
         */
        submitForm() {
            this.$v.$touch()
            if(this.$v.$invalid) {
            } else {
                this.goSave()
                this.loading = true
            }
        },
        getDataSearchAktif() {
            this.dataSearchAktif = [
                { value: '', text: 'Semua' },
                { value: '0', text: 'Tidak Aktif' },
                { value: '1', text: 'Aktif' },
            ]
        },
        getDataAktif() {
            this.dataAktif = [
                { value: '0', text: 'Tidak Aktif' },
                { value: '1', text: 'Aktif' },
            ]
        },
        getDataStatus() {
            this.dataStatus = [
                { value: '1', text: 'Yes' },
                { value: '2', text: 'No' },
                { value: '3', text: 'Finished' },
            ]
        },
        getDataApproveBy() {
            this.dataApproveBy = [
                { value: '1', text: 'Atasan' },
                { value: '2', text: 'Pegawai' },
                { value: '3', text: 'Tidak' },
            ]
        }
    },
    mounted() {
        this.errorMessage = 'Find Your Data'
        this.getDataAktif()
        this.getDataStatus()
        this.getDataApproveBy()
        this.getDataSearchAktif()
    },
    computed: {
    }
}
</script>
<style scoped>
@media screen and (min-width: 1253px) and (max-width: 1358px) {
    .inputs-form {
        float:left;
        width:100%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 1168px) and (max-width: 1252px) {
    .inputs-form {
        float:left;
        width:100%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 1097px) and (max-width: 1167px) {
    .inputs-form {
        float:left;
        width:100%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 1036px) and (max-width: 1096px) {
    .inputs-form {
        float:left;
        width:100%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 992px) and (max-width: 1035px) {
    .inputs-form {
        float:left;
        width:100%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
@media screen and (min-width: 1359px){
    .inputs-form {
        float:left;
        width:100%;
        margin-right: 12px;
        background-color: rgba(249, 250, 252, 1);
    }
}
.btn-search {
    border-radius: 4px;
    width: 100%;
    background-color:rgba(48, 107, 221, 1);
    color: white;
}
.btn-search:hover {
    border-radius: 4px;
    width: 100%;
    background-color:rgba(48, 107, 255, 1);
    color: white;
}

.btn-add {
    border-radius: 4px;
    width: 100%;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color:white;
    color: rgba(16, 16, 16, 1);
    font-weight: 500;
    font-size: 14px;
}
.btn-add:hover {
    border-radius: 4px;
    width: 100%;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color: rgba(48, 107, 221, 1);
    color: white;
}
.btn-cancel {
    border-radius: 4px;
    width: 200px;
    float: left;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color:white;
    color: rgba(16, 16, 16, 1);
    font-weight: 500;
    font-size: 14px;
}
.btn-cancel:hover {
    border-radius: 4px;
    width: 200px;
    float: left;
    border: 1px solid rgba(48, 107, 221, 1);
    background-color: rgba(48, 107, 221, 1);
    color: white;
}
.reloadOn {
    float: left;
    cursor: pointer;
    transform: rotate(-180deg);
    transition: 300ms linear all;
}
.reloadOff {
    float: left;
    cursor: pointer;
    transform: rotate(180deg);
    transition: 300ms linear all;
}
div.search-area {
    padding-top: 12px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 6px !important;
    background-color: white;
    z-index: 1;
}
div.sticky1 {
    position: -webkit-sticky;
    position: sticky;
    top: 54px;
    padding-top: 6px;
    padding-right: 20px;
    padding-left: 20px;
    padding-bottom: 12px !important;
    background-color: white;
    z-index: 1;
}
input {
    background-color: rgba(249, 250, 252, 1);
}

.area-edit {
    background-color: white;
    border-bottom: 1px solid rgba(238, 238, 238, 1);
}
.area-back {
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 8px;
    padding-bottom: 8px;
}
.area-input {
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 8px;
    padding-bottom: 8px;
}
.area-input label {
    font-size: 12px;
    color: rgba(154, 154, 154, 1);
    font-weight: 600;
    margin-bottom: 12px;
}
.area-input input, .area-input .model-select {
    background-color: white;
    margin-bottom: 20px;
}
.area-button-submit {
    padding-left: 20px;
    padding-bottom: 20px;
}
.btn-edit-submit {
    border-radius: 4px;
    float: left;
    width: 200px;
    background-color:rgba(48, 107, 221, 1);
    color: white;
    font-size: 14px;
}
.btn-edit-delete {
    border-radius: 4px;
    float: left;
    width: 200px;
    background-color:red;
    color: white;
    font-size: 14px;
}
.alert-area {
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 16px;
    padding-bottom: 16px;
    background-color: rgba(48, 107, 221, 1);
    text-align: center;
    color: white;
    font-size: 14px;
}
</style>